import { takeLatest, put, call, select, take, race, fork, delay } from 'redux-saga/effects';

import { SELECT_DEALER } from 'constants/ActionTypes';
import * as attentionPointsAction from 'modules/appointments/actions/attentionPoints';
import * as detailsActions from 'modules/appointments/actions/details';
import * as actionTypes from 'modules/appointments/actionTypes';

import AppointmentDetailsSaga from './appointment.saga';
import AppointmentDashboardSaga from './appointmentDashboard.saga';
import CoreSaga from './core.saga';
import LockerDetailsSaga from './lockersDetails.saga';
import { navigateToAppointmentDetails } from '../../../actions/navigateActions';
import { getSelectedDealerId } from '../../../selectors/dealerSelectors';

function* refreshAttentionPoint(delayInMs = 30000) {
  while (true) {
    try {
      let dealerId = yield select(getSelectedDealerId);
      if (!dealerId) {
        yield take(SELECT_DEALER);
        dealerId = yield select(getSelectedDealerId);
      }
      yield put(attentionPointsAction.fetchAll({ dealerId }));
      yield delay(delayInMs);
    } catch (errorMessage) {
      yield put(attentionPointsAction.fetchFailure(errorMessage));
    }
  }
}

function* fetchAttentionPointsFromDealer({ meta }) {
  if (meta?.source === 'keydeposit' || meta?.source === 'appointments_dashboard') {
    yield put(attentionPointsAction.startFetchPolling());
  }
}

function* pollTaskWatcher() {
  while (true) {
    const action = yield take(actionTypes.FETCH_ATTENTION_POINTS_START_POLLING);
    yield race([
      call(refreshAttentionPoint, action?.payload?.delay),
      take(SELECT_DEALER),
      take(actionTypes.FETCH_ATTENTION_POINTS_FAILURE),
      take(actionTypes.FETCH_ATTENTION_POINTS_STOP_POLLING),
    ]);
  }
}

function* navigateToDetails({ payload }) {
  const { id } = payload;

  yield put(detailsActions.setSelectedId(id));
  yield call(navigateToAppointmentDetails, id);
}

export default function* appointmentSagas() {
  yield takeLatest(SELECT_DEALER, fetchAttentionPointsFromDealer);
  yield takeLatest(actionTypes.NAVIGATE_TO_DETAILS, navigateToDetails);

  yield fork(CoreSaga);
  yield fork(LockerDetailsSaga);
  yield fork(AppointmentDetailsSaga);
  yield fork(AppointmentDashboardSaga);

  yield fork(pollTaskWatcher);
}
